import React from 'react';
import { calculateVatPrice } from '../../../../../helpers/calculators';
import { formatCurrency } from '../../../../../helpers/formatters';
import { CurrencyNumber } from '../../../../../models/BrandedTypes';
import { AllTotals } from '../../../../../models/rewards/calor/Claim';
import { CylinderPurchaseDetails } from '../../../../../models/rewards/calor/ClaimForm';

export const DisplayTotal = ({total}: {total: CurrencyNumber}) => {
    return <span className='d-block text-center'>{formatCurrency(total)}</span>
}

const parseIntWithNanZero = (numberString: string) => parseInt(numberString) || 0;
const parseFloatWithNanZero = (numberString: string) => parseFloat(numberString) || 0;

export const calculateTotals = (
    purchaseDetails13kgCommercial: CylinderPurchaseDetails, 
    purchaseDetails13kgPatio: CylinderPurchaseDetails, 
    purchaseDetails19kgCommercial: CylinderPurchaseDetails,
    purchaseDetails47kgCommercial: CylinderPurchaseDetails): AllTotals => {

    const totalQuantity = 
        + parseIntWithNanZero(purchaseDetails13kgCommercial.quantity)
        + parseIntWithNanZero(purchaseDetails13kgPatio.quantity)
        + parseIntWithNanZero(purchaseDetails19kgCommercial.quantity)
        + parseIntWithNanZero(purchaseDetails47kgCommercial.quantity);

    const vatPercentage = totalQuantity > 19 ? 20 : 5;

    const totals13kgCommercial = calculateVatPrice(
        parseIntWithNanZero(purchaseDetails13kgCommercial.quantity) * parseFloatWithNanZero(purchaseDetails13kgCommercial.pricePerCylinder),
        purchaseDetails13kgCommercial.vatIncluded,
        vatPercentage);
    const totals13kgPatio = calculateVatPrice(
        parseIntWithNanZero(purchaseDetails13kgPatio.quantity) * parseFloatWithNanZero(purchaseDetails13kgPatio.pricePerCylinder),
        purchaseDetails13kgPatio.vatIncluded,
        vatPercentage);
    const totals19kgCommercial = calculateVatPrice(
        parseIntWithNanZero(purchaseDetails19kgCommercial.quantity) * parseFloatWithNanZero(purchaseDetails19kgCommercial.pricePerCylinder),
        purchaseDetails19kgCommercial.vatIncluded,
        vatPercentage);
    const totals47kgCommercial = calculateVatPrice(
        parseIntWithNanZero(purchaseDetails47kgCommercial.quantity) * parseFloatWithNanZero(purchaseDetails47kgCommercial.pricePerCylinder),
        purchaseDetails47kgCommercial.vatIncluded,
        vatPercentage);

    return {
        quantity: totalQuantity,
        totals13kgCommercial,
        totals13kgPatio,
        totals19kgCommercial,
        totals47kgCommercial,
        totalOfTotals: calculateVatPrice(totals13kgCommercial.incVat + totals13kgPatio.incVat + totals19kgCommercial.incVat + totals47kgCommercial.incVat, true, vatPercentage),
    };
}